/** Auto-generated SoftPlan room labels for R1AS — tools/softplan-web3d/extract-rooms.js */
export const R1AS_ROOM_LABELS = [
  {
    "name": "BATH",
    "position": [
      -1.82,
      2.236,
      1.156
    ]
  },
  {
    "name": "LAUN",
    "position": [
      -0.233,
      2.236,
      1.251
    ]
  },
  {
    "name": "BEDROOM",
    "position": [
      -1.673,
      2.236,
      -2.959
    ]
  },
  {
    "name": "HALL",
    "position": [
      -0.17,
      2.236,
      -0.416
    ]
  },
  {
    "name": "KITCHEN",
    "position": [
      1.937,
      2.236,
      1.123
    ]
  },
  {
    "name": "LIVING",
    "position": [
      1.94,
      2.236,
      -2.413
    ]
  }
];
